export const ENDPOINT_BASE_URL = import.meta.env.VITE_BASE_URL;

export const ENDPOINT_ROOT = `${ENDPOINT_BASE_URL}`;

// auth

export const ENDPOINT_SESSION = '/sessions';
export const ENDPOINT_CHALLENGE = '/auth/challenge';
export const ENDPOINT_CERT = '/auth/cert';
export const ENDPOINT_LOGIN = '/auth/login';
export const ENDPOINT_VALIDATE = '/auth/validate-code';

// lands

export const ENDPOINT_LAND_BY_ID = '/api/lands';
export const ENDPOINT_LAND_LIST = '/api/lands/by_type';
export const ENDPOINT_LAND_COUNT = '/api/lands/counts';

// projects

export const ENDPOINT_PROJECTS_POST = '/api/projects';
export const ENDPOINT_PROJECTS_LIST = '/api/projects';
export const ENDPOINT_PROJECTS_CONTOUR = '/api/projects/contour';
export const ENDPOINT_PROJECTS_ALL_CONTOURS =
  '/api/projects/find_all_contours_by_project_id';

// monitoring
export const ENDPOINT_MONITORING_REPUBLIC = '/api/projects/statistics/republic';
export const ENDPOINT_MONITORING_DISTRICT = '/api/projects/statistics/region';
export const ENDPOINT_MONITORING_FARMERS = '/api/farmers/by-project-district';
export const ENDPOINT_MONITORING_FARMERS_PROJECT = '/api/projects/statistics';
export const ENDPOINT_MONITORING_ACTIONS = '/api/farmers/actions';
export const ENDPOINT_MONITORING_FARMER_ACTIONS = '/api/farmers/actions_region';
export const ENDPOINT_MONITORING_PAYMENT = '/api/farmers-banks/payment';
export const ENDPOINT_MONITORING_DOWNLOAD = '/api/files/download_as_buffer';
export const ENDPOINT_MONITORING_FARMER_AREA =
  '/api/projects/project-area-by-district';

// genral

export const ENDPOINT_CURRENT_USER = '/api/users/get_current_user';
export const ENDPOINT_PLANTS = '/api/plants';
export const ENDPOINT_ORGANIZATIONS = '/api/organizations';
export const ENDPOINT_LAND_STATIC = '/api/land-types/static';
export const ENDPOINT_PLANTS_TYPES = '/api/plant-types';
export const ENDPOINT_FOND_TYPES = '/api/fond-types';
export const ENDPOINT_MASSIVE = '/api/massive';
export const ENDPOINT_LAND_TYPES = '/api/land-types';
export const ENDPOINT_REGIONS = '/api/regions';
export const ENDPOINT_DISTRICTS = '/api/districts/by_region';
export const ENDPOINT_COTTON_PLANS =
  '/api/projects/statistics/republic/cotton-plans';

// responsible users
export const ENDPOINT_RESPONSIBLE_USERS_COUNT =
  '/api/users/responsible-users/count';
export const ENDPOINT_RESPONSIBLE_USERS_COUNT_REPUBLIC =
  '/api/users/responsible-users/count/republic';
export const ENDPOINT_RESPONSIBLE_USERS_COUNT_REGION =
  '/api/users/responsible-users/count/region';
export const ENDPOINT_RESPONSIBLE_USERS_BY_DISTRICT =
  '/api/users/responsible-users/by-district';
export const ENDPOINT_STEWARDSHIP_REPUBLIC_ACTIONS =
  '/api/projects/statistics/republic/actions';
export const ENDPOINT_STEWARDSHIP_REGION_ACTIONS =
  '/api/projects/statistics/region/actions';
export const ENDPOINT_STEWARDSHIP_EMPLOYEE_ACTIONS =
  '/api/projects/statistics/user/actions';
export const ENDPOINT_RESPONSIBLE_USER_PROJECTS =
  '/api/projects/responsible-users';
export const ENDPOINT_RESPONSIBLE_USER_PROJECT_MONTHS =
  '/api/projects/responsible-users/actions/month';
export const ENDPOINT_RESPONSIBLE_USER_PROJECT_CONTOURS =
  '/api/projects/responsible-users/project-contours';
export const ENDPOINT_RESPONSIBLE_USER_CONTOUR_ACTIONS =
  '/api/projects/responsible-users/actions';
export const ENDPOINT_FARMER_ACTION_INSPECT =
  '/api/farmer-actions-by-project/inspect';

// reports

export const ENDPOINT_REPORTS = '/api/farmers/farmer-report';
export const ENDPOINT_ACTIONS = '/api/actions';
export const ENDPOINT_ACTIONS_BY_REGION_PLAN = '/api/actions/by-region-plan';
export const ENDPOINT_ACTIONS_BY_MONTH = '/api/actions/by-month';

export const ENDPOINT_MASTER_APPRENTICES_REPUBLIC =
  '/api/farmers/master-apprentices/republic';

export const ENDPOINT_MASTER_APPRENTICES_REGION =
  '/api/farmers/master-apprentices/region';

export const ENDPOINT_MASTER_APPRENTICES_DISTRICT =
  '/api/farmers/master-apprentices/district';

export const ENDPOINT_PROJECTS_MASTER_APPRENTICES =
  '/api/projects/master-apprentices/district';

export const ENDPOINT_PROJECT_DETAILS = '/api/projects/';

export const ENDPOINT_PROJECT_CONTOURS = '/api/projects/contours';

export const ENDPOINT_PROJECT_CONTOURS_ACTIONS_BY_MONTH =
  '/api/projects/contours/actions-by-month';

// cotton analytical
export const ENDPOINT_COTTON_ANALYTICAL =
  '/api/projects/statistics/cotton/actions-summary';
export const ENDPOINT_PROJECTS_AREA =
  '/api/projects/statistics/republic/projects-area';

export const ENDPOINT_COTTON_RATES =
  '/api/projects/statistics/republic/cotton-rates';

export const ENDPOINT_MASTER_APPRENTICES_RATES =
  '/api/farmers/master-apprentices/republic/rates';

export const ENDPOINT_MASTER_APPRENTICES_REGION_RATES =
  '/api/farmers/master-apprentices/region/rates';

export const ENDPOINT_MASTER_APPRENTICES_DISTRICT_RATES =
  '/api/farmers/master-apprentices/district/rates';
